import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Fonts, getColor } from 'core/utils/Styles';
import { StyledSubNavListItem } from './subNavStyles';
// Holiday icon revert 2023
const HollyIcon = loadable(() => import('core/icons/HollyIcon'));

class SubNavListItem extends PureComponent {
	render() {
		return (
			<StyledSubNavListItem href={this.props.href}>
				{this.props.text}
				{this.props.holidayIcon && <HollyIcon widht={17} height={17} />}
			</StyledSubNavListItem>
		);
	}

	static propTypes = {
		text: PropTypes.string.isRequired,
		href: PropTypes.string.isRequired,
		parentSlug: PropTypes.string.isRequired,
		holidayIcon: PropTypes.bool,
	}

	static defaultProps = {
		holidayIcon: false,
	}
}

export default SubNavListItem;
